import { render, staticRenderFns } from "./HeaderComparate.vue?vue&type=template&id=43bc7e7c&scoped=true&"
import script from "./HeaderComparate.vue?vue&type=script&lang=js&"
export * from "./HeaderComparate.vue?vue&type=script&lang=js&"
import style0 from "./HeaderComparate.vue?vue&type=style&index=0&id=43bc7e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc7e7c",
  null
  
)

export default component.exports